// Remote typography must not hold the application document's load event open.
// Keep the existing families, weights and font-display=swap URLs unchanged.
const fontStylesheets = [
  'https://api.fontshare.com/v2/css?f[]=satoshi@400,500,700,900&display=swap',
  'https://fonts.googleapis.com/css2?family=JetBrains+Mono:wght@400;500&family=Playfair+Display:ital@1&display=swap',
  'https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@400;500;600;700&family=JetBrains+Mono:wght@400;600;700&display=swap',
  // Inter is the v2 officer UI's body face (palette re-rule 2026-11-01).
  'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap',
]

function loadBrandFonts() {
  const existing = Array.from(
    document.head.querySelectorAll<HTMLLinkElement>('link[rel="stylesheet"]'),
    (link) => link.href
  )
  for (const href of fontStylesheets) {
    if (existing.includes(href)) continue
    const link = document.createElement('link')
    link.rel = 'stylesheet'
    link.href = href
    document.head.append(link)
  }
}

if (document.readyState === 'complete') {
  loadBrandFonts()
} else {
  window.addEventListener('load', loadBrandFonts, { once: true })
}

export {}
